var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIconGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.057.77H3.651C1.711.77.229 2.24.229 4.162v6.789h9.81L7.415 8.35a1.088 1.088 0 010-1.584 1.109 1.109 0 011.597 0l4.562 4.525a1.087 1.087 0 010 1.584l-4.562 4.526a1.109 1.109 0 01-1.597 0 1.088 1.088 0 010-1.584l2.624-2.603H.229v6.789c0 1.923 1.483 3.394 3.422 3.394h11.406c1.94 0 3.422-1.47 3.422-3.394V4.163C18.48 2.24 16.996.77 15.057.77z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconGrey);
export default __webpack_public_path__ + "static/media/logout-icon-grey.f7c7bf03085e241ac3d49bf9ed7bbf0a.svg";
export { ForwardRef as ReactComponent };